export enum NotificationActionType {
  REDIRECT = 'REDIRECT'
}
